import * as React from 'react'
import {Form, Input, Select, Row, Col, Button} from 'antd'
import {toast} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import apiRequest from '../hooks/ApiRequest'
import Layouts from '../components/Layouts'
import logo from '../static/images/New_logo.jpg'

toast.configure()
const {Option} = Select

class RegistrationForm extends React.Component {
  constructor() {
    super()
    this.state = {
      loggedIn: false,
      api: process.env.REACT_APP_BASE_URL_AUTH + '/api/Auth/register',
      // api:'https://localhost:7260/api/Auth/register',
      status: 'Active',
      roles: [], // Store fetched roles
      loading: false, // Manage loading state
    }
  }

  componentDidMount() {
    this.fetchRoles()
  }

  fetchRoles = async () => {
    this.setState({loading: true})
    try {
      const response = await apiRequest(
        process.env.REACT_APP_BASE_URL_AUTH + '/api/Auth/child-roles',
        'GET',
      )
      if (response.success) {
        this.setState({roles: response.data}) // Store roles
      } else {
        toast.error('Failed to fetch roles', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 5000,
        })
      }
    } catch (error) {
      console.error('Error fetching roles', error)
    } finally {
      this.setState({loading: false})
    }
  }

  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        values.status = this.state.status
        this.register(values)
      }
    })
  }

  async register(data) {
    const response = await apiRequest(
      this.state.api,
      'POST',
      data,
      localStorage.getItem('token'),
    )
    if (response.success) {
      toast.success(response.data.message, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 5000,
      })
      this.props.form.resetFields()
    } else {
      toast.error(response.error, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 5000,
      })
    }
  }

  render() {
    const {getFieldDecorator} = this.props.form
    const {roles, loading} = this.state

    return (
      <div
        title="Register"
        className="ant-layout-content dashboard">
        <div className="dash-bg-white">
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={24} lg={12}>
              <div className="section-top-heading">
                <h3
                  style={{
                    color: '#0C1362',
                    fontWeight: '600',
                    fontSize: '20px',
                  }}>
                  Register User
                </h3>
              </div>
            </Col>
          </Row>
        </div>
        <div className="dash-bg-white">
          <div className="container">
            <div className="login-aside bg-white flex items-center justify-center">
              <div className="form-wrapper">
                {/* <div className="logo-wrapper">
                  <img src={logo} alt="OutRisk logo" />
                </div> */}
                <Form onSubmit={this.handleSubmit} layout="vertical">
                  <div style={{display: 'flex', flexWrap: 'wrap', gap: '16px'}}>
                    <div style={{flex: '0 0 48%'}}>
                      <Form.Item label="First Name">
                        {getFieldDecorator('firstname', {
                          rules: [
                            {
                              required: true,
                              message: 'Please input your First name!',
                            },
                          ],
                        })(<Input placeholder="First name" />)}
                      </Form.Item>
                    </div>
                    <div style={{flex: '0 0 48%'}}>
                      <Form.Item label="Last Name">
                        {getFieldDecorator('lastname', {
                          rules: [
                            {
                              required: true,
                              message: 'Please input your Last name!',
                            },
                          ],
                        })(<Input placeholder="Last name" />)}
                      </Form.Item>
                    </div>
                    <div style={{flex: '0 0 48%'}}>
                      <Form.Item label="Email">
                        {getFieldDecorator('email', {
                          rules: [
                            {type: 'email', message: 'Invalid email!'},
                            {
                              required: true,
                              message: 'Please input your E-mail!',
                            },
                          ],
                        })(<Input placeholder="E-mail" />)}
                      </Form.Item>
                    </div>
                    <div style={{flex: '0 0 48%'}}>
                      <Form.Item label="Mobile Number">
                        {getFieldDecorator('mobileNumber', {
                          rules: [
                            {
                              required: true,
                              message: 'Please enter your mobile number',
                            },
                            {
                              pattern: /^\d{10}$/,
                              message: 'Phone number must be 10 digits',
                            },
                          ],
                        })(
                          <Input placeholder="Mobile Number" maxLength={10} />,
                        )}
                      </Form.Item>
                    </div>
                    <div style={{flex: '0 0 48%'}}>
                      <Form.Item label="Role">
                        {getFieldDecorator('roleId', {
                          rules: [
                            {
                              required: true,
                              message: 'Please select a role!',
                            },
                          ],
                        })(
                          <Select placeholder="Select a role" loading={loading}>
                            {roles.map(role => (
                              <Option key={role?.id} value={role?.id}>
                                {role?.roleName}
                              </Option>
                            ))}
                          </Select>,
                        )}
                      </Form.Item>
                    </div>
                    {/* Hidden Status Field */}
                    {getFieldDecorator('status')(
                      <Input type="hidden" value={this.state.status} />,
                    )}
                  </div>
                  <div style={{display: 'flex', justifyContent: 'center'}}>
                    <Form.Item>
                      <Button
                        type="primary"
                        size="default"
                        className="register-btn"
                        htmlType="submit">
                        REGISTER
                      </Button>
                    </Form.Item>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const WrappedRegistrationForm = Form.create({name: 'registration_form'})(
  RegistrationForm,
)
export default WrappedRegistrationForm